/**
 * OWNEXP Slice 11 — Status-Tokens v2 (TK-30..34, DNA 06 §7):
 * - TK-30 unavailable/unknown sind eigene, gedämpfte Töne (nie 0, nie success).
 * - TK-31 waiting ≠ warning: Warten ist Normalbetrieb, Warnung ist Abweichung.
 * - TK-32 Severity-Töne (critical) nur bei Wert > 0 darstellen.
 * - TK-33 rolled_back → warning (keine Erfolgsfarbe).
 * - TK-34 Fallback für unbekannte Rohcodes: unknown (gedämpft), nie neutral-gefälscht.
 */

export const STATUS_TONES = [
  "neutral",
  "info",
  "success",
  "ready",
  "waiting",
  "warning",
  "danger",
  "critical",
  "blocked",
  "unavailable",
  "unknown",
] as const;
export type StatusTone = (typeof STATUS_TONES)[number];

const STATUS_MAP: Record<string, StatusTone> = {
  active: "info",
  acting: "info",
  executing: "info",
  verifying: "info",
  planning: "info",
  queued: "info",
  running: "info",
  ready: "ready",
  ready_to_resume: "ready",
  completed: "success",
  done: "success",
  applied: "success",
  approved: "success",
  verified: "success",
  // TK-31: Warten ist ein eigener Ton — bewusst NICHT warning.
  waiting: "waiting",
  wait_owner: "waiting",
  wait_human: "waiting",
  wait_resource: "waiting",
  wait_external: "waiting",
  wait_dependency: "waiting",
  awaiting_approval: "warning",
  waiting_for_owner: "waiting",
  recovering: "warning",
  paused: "warning",
  parked: "neutral",
  // TK-33: Zurücknehmen ist keine Erfolgsgeschichte.
  rolled_back: "warning",
  failed: "danger",
  error: "danger",
  rejected: "danger",
  cancelled: "danger",
  stopped: "danger",
  no_go: "danger",
  critical: "critical",
  blocked: "blocked",
  fail_closed: "blocked",
  disabled: "blocked",
  inactive: "neutral",
  idle: "neutral",
  // TK-30: Datenzustände sind niemals „gut" oder 0 — gedämpft eigene Töne.
  unavailable: "unavailable",
  unknown: "unknown",
  not_measured: "unknown",
};

export function normalizeStatusTone(status: string | null | undefined): StatusTone {
  // TK-34: unbekannter Rohcode → unknown (gedämpft), niemals neutral vorgetäuscht.
  return STATUS_MAP[String(status ?? "").trim().toLowerCase()] ?? "unknown";
}
